export const COLORS = {
    burgundy: {
        900: '#3d0d18',
        800: '#5e1e2a',
        700: '#7a2438',
        600: '#8f3f4d',
        500: '#a8656e',
        100: '#f3e5e7',
        50: '#fbf7f6',
    },
    ink: '#2a1a1d',
    white: '#fff7f8',
};
